import { optionSubcategory_resourceScheduling } from './resourceSchedulingSubCategory.locstring.json';
import {
    lazyInitResourceSchedulingSetting,
    ResourceSchedulingOption,
    ResourceSchedulingPermissions,
    ResourceSchedulingResponse,
} from 'owa-resource-scheduling-option';
import { OptionSubCategory } from 'owa-options-core';

const resourceSchedulingSubCategory: OptionSubCategory = {
    key: 'resourceScheduling',
    titleStringKey: optionSubcategory_resourceScheduling,
    options: [ResourceSchedulingOption, ResourceSchedulingPermissions, ResourceSchedulingResponse],
    onSelected: () => {
        return lazyInitResourceSchedulingSetting.importAndExecute();
    },
};

export default resourceSchedulingSubCategory;
